import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator, enableNetwork, disableNetwork } from 'firebase/firestore';
import { getAuth, connectAuthEmulator, RecaptchaVerifier } from 'firebase/auth';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { envConfig } from './environment';

// Get Firebase configuration from environment service
const firebaseConfig = envConfig.getFirebaseConfig();

// Validate Firebase configuration
const validateConfig = () => {
  const requiredKeys: (keyof typeof firebaseConfig)[] = ['apiKey', 'authDomain', 'projectId', 'storageBucket', 'messagingSenderId', 'appId'];
  const missingKeys = requiredKeys.filter(key => !firebaseConfig[key]);
  
  if (missingKeys.length > 0) {
    const error = `Missing Firebase configuration: ${missingKeys.join(', ')}`;
    if (envConfig.isProduction()) {
      throw new Error(error);
    }
  }
};

// Validate configuration before initializing
validateConfig();

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app, firebaseConfig.databaseId);
export const auth = getAuth(app);
export const storage = getStorage(app);

// Export network control functions
export { enableNetwork, disableNetwork };

// Setup reCAPTCHA verifier for phone authentication
export const setupRecaptcha = (containerId: string): RecaptchaVerifier => {
  // Clear any existing reCAPTCHA in the container first
  const container = document.getElementById(containerId);
  if (container) {
    container.innerHTML = '';
  }
  
  return new RecaptchaVerifier(auth, containerId, {
    size: 'normal',
    callback: () => {
    },
    'expired-callback': () => {
    }
  });
};

export default app;
